import { useNavigate } from 'react-router-dom';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { AMCForm, type AMCFormValues } from '../components/AMCForm';
import { useCreateAMCMutation } from '@/services/amcApi';

const initialValues: AMCFormValues = {
  name: '',
  fundCode: '',
  isRTA: false,
  useExternalUpiWebhook: false,
};

const CreateAMC = () => {
  const navigate = useNavigate();
  const [createAMC] = useCreateAMCMutation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSubmit = async (values: AMCFormValues, logo?: string) => {
    console.log(values);
    const result = await createAMC({ ...values, ...(logo && { logo }) }).unwrap();
    navigate(`/amcs/${result.id}`);
  };

  return (
    <Box sx={{ p: isMobile ? 1 : 3 }}>
      <Typography variant="h4" sx={{ mb: 4, textAlign: 'center' }}>
        Create New AMC
      </Typography>
      <AMCForm
        initialValues={initialValues}
        onSubmit={handleSubmit}
        submitButtonText="Create AMC"
      />
    </Box>
  );
};

export default CreateAMC;
